import { render, staticRenderFns } from "./PieChartStatus.vue?vue&type=template&id=6ec1d668&scoped=true&"
import script from "./PieChartStatus.vue?vue&type=script&lang=js&"
export * from "./PieChartStatus.vue?vue&type=script&lang=js&"
import style0 from "./PieChartStatus.vue?vue&type=style&index=0&id=6ec1d668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1d668",
  null
  
)

export default component.exports